module.exports = __webpack_public_path__ + "img/mpp_banner.4ff817dc.png";